import { render, staticRenderFns } from "./GeneralSettingContactAddressName.vue?vue&type=template&id=627d1f46&"
import script from "./GeneralSettingContactAddressName.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingContactAddressName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports